module.exports = __webpack_public_path__ + "static/media/OSCURIDAD.74c24d3c.png";